enum HeroCopyrightPosition {
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT',
  BottomRight = 'BOTTOM_RIGHT',
  BottomLeft = 'BOTTOM_LEFT'
}

export default HeroCopyrightPosition
